<template>
  <v-app>
    
      <fs-loader></fs-loader>
      <!--
      <link rel="stylesheet" 
            href="https://use.fontawesome.com/releases/v5.6.3/css/all.css" 
            integrity="sha384-UHRtZLI+pbxtHCWp1t77Bi1L4ZtiqrqD80Kn4Z8NTSRyMA2Fd33n5dQ8lWUE00s/" 
            crossorigin="anonymous">
      -->
      <link href="https://fonts.googleapis.com/css?family=Open+Sans" rel="stylesheet">

      <link rel="stylesheet" 
            href="https://pro.fontawesome.com/releases/v5.8.2/css/all.css" 
            integrity="sha384-xVVam1KS4+Qt2OrFa+VdRUoXygyKIuNWUUUBZYv+n27STsJ7oDOHJgfF0bNKLMJF" 
            crossorigin="anonymous">
      <router-view></router-view>
      
    

  </v-app>
</template>

<script>
import FsLoader from "./components/global/FsLoader"


export default {
  name: 'app',
  components:{
    FsLoader
  }
}
</script>

<style>

</style>
